<template>
  <transition
    name="megasubmenu"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
  >
    <slot />
  </transition>
</template>

<script setup>
const beforeEnter = (el) => {
  if (window.innerWidth < 992) el.style.height = '0'
}

const enter = (el) => {
  if (window.innerWidth < 992) el.style.height = `${el.scrollHeight}px`
}

const afterEnter = (el) => {
  el.style = ''
}

const beforeLeave = (el) => {
  if (window.innerWidth < 992) el.style.height = `${el.scrollHeight}px`
}
</script>
